import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function voidInspectionReport(id, payload) {
  const { data: raw } = await request.post(
    `/ims/inspection-reports/${id}/void`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}

export async function voidMaterialSn(id, payload) {
  const { data: raw } = await request.post(
    `/ims/material-sns/${id}/void`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
